import { ExternalLink, BarChart3 } from 'lucide-react'
import styles from './CostReportsPage.module.css'

const COST_MANAGER_URL = 'https://nxtgenpe.apteancloud.dev/cost-manager/dashboard'

export function CostReportsPage() {
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.headerIcon}>
            <BarChart3 size={20} />
          </div>
          <div>
            <h1 className={styles.pageTitle}>Cost Reports</h1>
            <p className={styles.pageSubtitle}>Azure cost breakdown and spend analytics</p>
          </div>
        </div>
        <a
          href={COST_MANAGER_URL}
          target="_blank"
          rel="noreferrer"
          className={styles.openBtn}
        >
          <ExternalLink size={14} />
          Open in new tab
        </a>
      </div>

      <div className={styles.iframeCard}>
        <iframe
          src={COST_MANAGER_URL}
          title="Cost Reports"
          className={styles.iframe}
          allow="clipboard-read; clipboard-write"
        />
      </div>
    </div>
  )
}
